import axios from 'axios';
import store from './store';
import config from './config';
import router from './router';
// request with cookie
// axios.defaults.withCredentials = true;
// axios.defaults.baseURL = "http://localhost:8011";
// let ax = axios,
//     post = axios.post;
const service = axios.create({
    baseURL: "/kinktest",//联调时使用
    withCredentials: true // 请求携带cookie
})
// //保存验证码之前的请求
// let beforeVerify = null;
// let createBeforeVerify = function (resolve, args) {
//     store.commit('changeVerify', true);
//     beforeVerify = function () {
//         ax.post.apply(this, args).then((data, msg, status) => {
//             resolve(data, msg, status);
//             store.commit('setVerified', true);
//             store.commit('changeVerify', false);
//         })
//     }
// };
//当前正在请求的请求数
let requestCount = 0;
// 请求拦截器
service.interceptors.request.use(
    config => {
        // 在请求发送之前做一些处理
        if (requestCount++ == 0)
            store.commit('changePending', true)
        config.headers = config.headers ? config.headers : {}
        config.headers.userToken = store.state.token
        return config
    }
)

function createError(message, show = true) {
    if (show)
        errorLog(message)
    throw new Error(message)
}

function errorLog(message) {
    store.commit('message', message)
}

// 响应拦截器,返回数据结构{status:200,data:object,message:''}状态码、数据、附带信息
service.interceptors.response.use(
    response => {
        if (--requestCount == 0)
            store.commit('changePending', false);
        // dataAxios 是 axios 返回数据中的 data
        const dataAxios = response.data
        // 这个状态码是和后端约定的
        const {status} = dataAxios
        // 根据 status 进行判断
        if (status == undefined) {
            createError(config.request_error_msg)
        } else {
            // 有 status 代表这是一个后端接口 可以进行进一步的判断
            switch (status) {
                case config.result_success:
                    return dataAxios.data
                case config.result_out_date://超时跳转到登录页面
                    store.commit('logout')
                    router.push('/signin')
                    createError(config.out_time_msg)
                    break
                case config.result_verified:
                    store.commit('changeVerify', true)
                    createError("", false)
                    break
                case config.result_manager:
                    router.push('/manager_validate')
                    createError("", false)
                    break
                default:
                    // 不是正确的 code
                    createError(dataAxios.message || config.request_error_msg)
            }
        }
    },
    error => {
        if (--requestCount == 0)
            store.commit('changePending', false)
        errorLog(error.message || config.request_error_msg)
        return Promise.reject(error)
    }
)

// ax.post = function () {
//     store.commit('changePending', true);
//     let args = arguments;
//     let p1 = post.apply(axios, args);
//     return new Promise((resolve, reject) => {
//         p1.then((res) => {
//             let d = res.data;
//             if (typeof d === 'string') {
//                 d = JSON.stringify(d);
//             }
//             //请求成功
//             if (d.status === config.result_success) {
//                 //如果是验证码返回成功
//                 if (beforeVerify !== null && args[0] === config.do_verify_url) {
//                     //执行验证码之前的请求
//                     beforeVerify();
//                     beforeVerify = null;
//                 }
//                 resolve(d.data);
//             }
//             //请求失败
//             else if (d.status === config.result_fail) {
//                 reject(d);
//             }
//             // 登录超时,跳转到登录界面
//             else if (d.status === config.result_out_date) {
//                 store.commit('message', config.out_time_msg);
//                 store.commit('logout');
//                 router.push('/signin');
//             }
//             //需要输入验证码，存储上次的请求参数，验证码输入完成后再次执行
//             else if (d.status === config.result_verified) {
//                 createBeforeVerify(resolve, args);
//             }
//             // 其他情况
//             else {
//                 reject(d);
//             }
//             store.commit('changePending', false);
//         }).catch((err) => {
//             console.error(err);
//             reject({message: config.request_error_msg});
//         })
//     }).catch((data) => {
//         store.commit('message', data && data.message || config.request_error_msg);
//         store.commit('changePending', false);
//     });
// };
export default {
    axios: service
}
